export default "__VITE_ASSET__e444b9ac__"